<template>
  <gmap-map
    :center="this.center"
    :zoom="15"
    :options="{styles: styles, gestureHandling: 'cooperative',mapTypeControl:false,streetViewControl:false}"
    ref="mapArtwork"
    :marker="this.center"
    class="map-location-canvas"
  >
  <gmap-marker
      :position="center"
      :clickable="false"
      :draggable="false"
      :icon="icon"
    ></gmap-marker>
  </gmap-map>
</template>

<script>
  export default {
    name:'mapArtwork',
    props: ['lat','lng'],
    mounted() {
      
    },
    data () {
      return {
        data:[],
        // icon: {url:'https://digital.rigabiennial.com/static/map-marker.png'},
        icon: {url:'/static/icon-triangle.svg',scaledSize: new google.maps.Size(15, 15),anchor: new google.maps.Point(0, 15)},
        markers:[],
        center: {'lat':this.lat, 'lng':this.lng},
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"saturation":"-100"},{"lightness":"57"}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"lightness":"1"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.bus","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.bus","elementType":"labels.text.fill","stylers":[{"saturation":"0"},{"lightness":"0"},{"gamma":"1.00"},{"weight":"1"}]},{"featureType":"transit.station.bus","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"weight":"1"},{"lightness":"0"}]},{"featureType":"transit.station.rail","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.rail","elementType":"labels.text.fill","stylers":[{"gamma":"1"},{"lightness":"40"}]},{"featureType":"transit.station.rail","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#d2d2d2"},{"visibility":"on"}]}]
      }
    },
  }
</script>

<style media="screen">

  .map-location-canvas {
    width: 100%;
    height: 200px;
    margin-top: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/MapArtwork.vue